import React from 'react'

const Logo = class extends React.Component {
  render() {
    return (
      <h1 style={{color: 'rgb(255,68,0)'}}>RECETAS QUICK</h1>
    )
  }
}

export default Logo
